module.exports = __webpack_public_path__ + "img/V21.2f53a113.png";